import React from 'react'
import { 
  Card, 
  CardContent, 
  Typography, 
  TextField, 
  Button, 
  Box, 
  Grid,
  IconButton
} from '@mui/material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import DeleteIcon from '@mui/icons-material/Delete'

const HospitalInfo = ({ 
  hospitalInfo, 
  handleHospitalInfoChange, 
  handleHospitalInfoSubmit 
}) => {
  const handleImageUpload = (event) => {
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        handleHospitalInfoChange('image', reader.result)
      }
      reader.readAsDataURL(file)
    }
  }

  const handleRemoveImage = () => {
    handleHospitalInfoChange('image', '')
  }

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Hospital Information
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Please enter your hospital's basic information
        </Typography>
        
        <TextField
          fullWidth
          label="Hospital Name"
          value={hospitalInfo.name}
          onChange={(e) => handleHospitalInfoChange('name', e.target.value)}
          sx={{ mb: 2 }}
        />
        
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" gutterBottom>
            Hospital Photo
          </Typography>
          {hospitalInfo.image ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <img 
                src={hospitalInfo.image} 
                alt="Hospital photo" 
                style={{ maxWidth: '100px', maxHeight: '100px', objectFit: 'contain' }} 
              />
              <IconButton 
                color="error" 
                onClick={handleRemoveImage}
                size="small"
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          ) : (
            <Button
              component="label"
              variant="outlined"
              startIcon={<CloudUploadIcon />}
              sx={{ mb: 1 }}
            >
              Upload Photo
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={handleImageUpload}
              />
            </Button>
          )}
        </Box>
        
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Hospital Description"
          value={hospitalInfo.description}
          onChange={(e) => handleHospitalInfoChange('description', e.target.value)}
          sx={{ mb: 2 }}
        />
        
        <TextField
          fullWidth
          label="Hospital Address"
          value={hospitalInfo.address}
          onChange={(e) => handleHospitalInfoChange('address', e.target.value)}
          sx={{ mb: 2 }}
        />
        
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="City"
              value={hospitalInfo.city}
              onChange={(e) => handleHospitalInfoChange('city', e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="State"
              value={hospitalInfo.state}
              onChange={(e) => handleHospitalInfoChange('state', e.target.value)}
            />
          </Grid>
        </Grid>
        
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            onClick={handleHospitalInfoSubmit}
            disabled={!hospitalInfo.name || !hospitalInfo.description || !hospitalInfo.address}
          >
            Continue
          </Button>
        </Box>
      </CardContent>
    </Card>
  )
}

export default HospitalInfo 